import {Helmet} from "react-helmet-async";
import VideoSource from "../cards/VideoSource";
import {Link} from "react-router-dom";

const availableWidths = [480, 720, 1080];
const Home = () => {
    const path = "https://thekroot.com/assets/video/showreel/main_2025"
    // const path = process.env.PUBLIC_URL + "/assets/video/showreel/main_2025";

    return (
        <main className="home">
            <Helmet>
                <title>The Kroot - VFX and animation</title>
                <meta content="The Kroot" property="og:title"/>
                <meta content="The Kroot" property="twitter:title"/>
                <meta name="description"
                      content="The Kroot provides Unreal Engine, Character Animation, Traditional Animation,
          Beauty and other VFX services for tv show , music videos and commercial."
                />
                <meta
                    name="keywords"
                    content="Unreal Engine, VFX, Animation, TV shows, Music videos, Commercials, Character Animation, Traditional Animation"
                />
                <meta property="og:image" content="https://www.thekroot.com/logo512.png"/>
                <meta property="og:type" content="website"/>
                <meta property="og:url" content="https://www.thekroot.com/"/>
                <meta name="twitter:image" content="https://www.thekroot.com/logo512.png"/>
                <meta name="twitter:card" content="summary_large_image"/>
            </Helmet>
            <section className="home__flex relative">
                <VideoSource path={path} name={"main"} className={`main-video fs-36`} text={""} width={availableWidths}/>
                <Link to={"/our_showreels"}
                      className="home__card-link fs-40"
                >
                    OUR SHOWREELS
                </Link>
            </section>
        </main>
    )
}
export default Home

